<template>
  <el-row class="container">
    <phone style="float:left" @current-change="currentChange" :preview="preview" :tool="tool"></phone>
    <el-form class="form" size="mini" label-width="80px">
      <el-form-item label="页面间距" prop="title">
        <el-slider v-model="page.style.padding" style="padding-left: 10px;"></el-slider>
      </el-form-item>
      <el-form-item label="预览模式" prop="title">
        <el-radio-group v-model="preview">
          <el-radio :label="1" border>长图</el-radio>
          <el-radio :label="2" border>滚动</el-radio>
        </el-radio-group>
        <el-button class="preview-btn" type="primary" size="mini" icon="el-icon-picture" @click="showPreviewQRcode">扫码预览</el-button>
      </el-form-item>
    </el-form>
    <data-box
      :style="{marginTop:marginTop+'px'}"
      style="float:left;margin-left:30px;">
    </data-box>
    <el-dialog
      title="扫码预览"
      :visible.sync="dialogVisible"
      center
      append-to-body
      width="500px"
      :before-close="handleClose">
      <div class="qrcode">
        <img :src="`data:image/jpeg;base64,${qrcode}`">
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import request from '@/utils/request'
import phone from './phone'
import dataBox from './dataBox'
// import './link/index'
export default {
  name: 'editLayout',
  components: {
    phone,
    dataBox
  },
  props: {
    tool: {
      type: Array,
      default () {
        return [
          'swiper',
          'images',
          'collapse',
          'richtext',
          'videoPlayer',
          'wtitle',
          'people',
          'description',
          'movie',
          'peopleDescribe',
          'interview',
          'interviewVideo',
          'guest',
          'talkList',
          'screeningList',
          'moviePanorama',
          'movieTrack',
          'discussion',
          'topic'
        ]
      }
    }
  },
  data () {
    return {
      preview: 2,
      dialogVisible: false,
      marginTop: 140,
      qrcode: '',
      data: {
        style: {
          padding: 10,
          backgroundColor: '#ffffff',
          navigationBarBackgroundColor: '#ffffff',
          title: '首页',
          name: '中秋活动首页'
        },
        modules: []
      },
      timer: null
    }
  },
  computed: {
    page () {
      return this.$store.state.page
    }
  },
  methods: {
    currentChange (event) {
      if (this.preview === 1) {
        if (event.path) {
          event.path.forEach(element => {
            if (element.className && element.className.indexOf('component-item') > -1) {
              this.marginTop = element.offsetTop + 130
            }
          })
        } else if (event.originalTarget) {
          this.marginTop = event.originalTarget.offsetParent.offsetTop + 130
        }
      } else {
        this.marginTop = 140
      }
    },
    handleClose (done) {
      clearInterval(this.timer)
      done()
    },
    showPreviewQRcode () {
      if (this.qrcode) {
        this.dialogVisible = true
        return
      }
      let sendData = {
        page: {
          style: this.page.style,
          modules: this.page.data
        }
      }
      request({
        url: 'page-preview',
        method: 'post',
        data: sendData
      }).then(res => {
        this.dialogVisible = true
        this.qrcode = res.data.qrcode
        this.qrcode_uuid = res.data.uuid
        this.updatePreview()
      })
    },
    updatePreview () {
      this.timer = setInterval(_ => {
        let sendData = {
          page: {
            style: this.page.style,
            modules: this.page.data
          }
        }
        request({
          url: 'page-preview/' + this.qrcode_uuid,
          method: 'put',
          data: sendData
        }).then()
      }, 3 * 1000)
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  beforeRouteLeave () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  float: left;
  line-height: 1;
}
.form {
  width: 600px;
  border: 1px solid #dddddd;
  border-radius: 10px;
  padding: 10px 25px 0 10px;
  float: left;
  position: absolute;
  top: 0;
  left: 350px;
  .preview-btn {
    margin-left: 30px;
  }
}
.qrcode {
  width: 250px;
  height: 250px;
  margin: 0 auto;
  padding-bottom: 50px;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/editBox.vue